import { SettingsPage } from 'Features/Projects/Scenarios/EditSettings/SettingsPage'
import {
  useInventoryResults,
  useInventorySummary,
} from 'Features/Projects/Scenarios/Inventory/Inventory.data'
import { InventorySummary } from 'Features/Projects/Scenarios/Inventory/Inventory.types'
import { Alert } from '@mui/material'
import { useParams } from 'react-router-dom'
import { Loader } from 'Common/Loader/Loader'
import { ErrorDisplay } from 'Common/Error/Error'
import { InventoryResultsTable } from 'Features/Projects/Scenarios/Inventory/Inventory.results.table'

export const InventoryResultsView = () => {
  const { projectId, scenarioId } = useParams<{
    projectId: string
    scenarioId: string
  }>() as { projectId: string; scenarioId: string }

  const { data, isLoading, isError, isRefetching } = useInventoryResults({
    projectId,
    scenarioId,
  })

  // Sites whose results predate a change to their replenishment settings.
  const { data: sites } = useInventorySummary({ projectId, scenarioId })
  const stale = ((sites ?? []) as InventorySummary[]).filter(
    (site) => site.safetyStockStale || (site.coupledCyclesOutOfDate ?? 0) > 0
  )

  return (
    <SettingsPage title="Inventory results">
      {stale.length > 0 && (
        <Alert severity="warning" sx={{ mb: 1.5 }}>
          Safety stock for {stale.map((site) => site.siteCode).join(', ')} is
          out of date: its replenishment settings or coupled cycles changed
          after it was calculated. See Inventory summary for each site.
        </Alert>
      )}
      {isLoading && <Loader />}
      {isError && <ErrorDisplay />}
      {data && (
        <InventoryResultsTable data={data} isRefetching={isRefetching} />
      )}
    </SettingsPage>
  )
}
